import React from "react";
import { watchTime } from "../lib/wakeTimer";

// 정해진 시각(ms)이 지나면 한 번 알린다 — 자정이 아닌 때 닫히는 창(자동 종료 안내 168시간 등)을 열어 둔 화면에서도 닫히게(135차 #1).
// onWake 가 없으면 이 컴포넌트를 다시 그린다. 시각이 없으면 아무것도 하지 않는다. 기다리는 규칙은 watchTime 한 곳(137차 #4).
//   · 그린 뒤 효과가 돌 때 이미 지났으면 바로 알린다 — 경계 직전에 만든 뷰가 그대로 남지 않게(140차 #1)
//   · 같은 시각으로는 한 번만 알린다. 알린 뒤 다시 그렸는데 같은 시각이 돌아오고 아직 그 시각 전이면(기기 시계를 되돌림) 다시 기다린다(141차 #4)
export default function useWakeAt(at, onWake) {
  const [nonce, setNonce] = React.useState(0);
  const cb = React.useRef(onWake);
  cb.current = onWake;
  const firedRef = React.useRef(null);
  React.useEffect(() => {
    if (!Number.isFinite(at)) return undefined;
    const fire = () => {
      firedRef.current = at;
      setNonce((n) => n + 1);   // 다시 그림 + 이 효과를 다시 돌려 같은 시각이 돌아왔는지 본다
      if (cb.current) cb.current();
    };
    if (at <= Date.now()) {
      if (firedRef.current !== at) fire();
      return undefined;
    }
    return watchTime(() => at, () => { fire(); return false; });
  }, [at, nonce]);
}
